export const xAPI_IA = {
    /* 홈(HOM) */
    HOME: {
        IA: {
            gnb: "HOM",
        },
    },

    // 로그인
    LOGIN: {
        IA: {
            gnb: "LOI",
        },
    },

    /* SMART내신(SMT) */
    SMART_ALL: {
        IA: {
            gnb: "SMT",
            lnbNm1: "전체강좌",
            lnbCd1: "SMTAL",
        },
    },
    SMART_NASIN: {
        IA: {
            gnb: "SMT",
            lnbNm1: "내신진도",
            lnbCd1: "SMT00",
        },
    },
    SMART_VACA: {
        IA: {
            gnb: "SMT",
            lnbNm1: "방학특강",
            lnbCd1: "SMT01",
        },
    },
    SMART_EXAM: {
        IA: {
            gnb: "SMT",
            lnbNm1: "시험특강",
            lnbCd1: "SMT02",
        },
    },
    SMART_PREMID: {
        IA: {
            gnb: "SMT",
            lnbNm1: "예비중",
            lnbCd1: "SMT03",
        },
    },
    SMART_PREHIGH: {
        IA: {
            gnb: "SMT",
            lnbNm1: "고등과정",
            lnbCd1: "SMT04",
        },
    },

    /* 대치TOP(TOP) */
    DTOP_ALL: {
        IA: {
            gnb: "TOP",
            lnbNm1: "전체강좌",
            lnbCd1: "TOPAL",
        },
    },
    DTOP_DEEPTHINK: {
        IA: {
            gnb: "TOP",
            lnbNm1: "깊은생각",
            lnbCd1: "TOP00",
        },
    },
    DTOP_FUTRSRCH: {
        IA: {
            gnb: "TOP",
            lnbNm1: "미래탐구(과학)",
            lnbCd1: "TOP01",
        },
    },
    DTOP_FUTRSRCHK: {
        IA: {
            gnb: "TOP",
            lnbNm1: "미래탐구(국어)",
            lnbCd1: "TOP02",
        },
    },
    DTOP_ILE: {
        IA: {
            gnb: "TOP",
            lnbNm1: "ILE",
            lnbCd1: "TOP03",
        },
    },
    DTOP_APROACDY: {
        IA: {
            gnb: "TOP",
            lnbNm1: "에이프로아카데미",
            lnbCd1: "TOP04",
        },
    },
    DTOP_HAMMATH: {
        IA: {
            gnb: "TOP",
            lnbNm1: "함수학학원",
            lnbCd1: "TOP05",
        },
    },
    DTOP_HAMEN: {
        IA: {
            gnb: "TOP",
            lnbNm1: "함영원영어학원",
            lnbCd1: "TOP06",
        },
    },
    DTOP_WRACDY: {
        IA: {
            gnb: "TOP",
            lnbNm1: "세계로학원",
            lnbCd1: "TOP07",
        },
    },
    DTOP_CNA: {
        IA: {
            gnb: "TOP",
            lnbNm1: "C&A논술학원",
            lnbCd1: "TOP08",
        },
    },

    /* 영어전문관(ENG) */
    ENGMP_ALL: {
        IA: {
            gnb: "ENG",
            lnbNm1: "전체강좌",
            lnbCd1: "ENGAL",
        },
    },
    ENGMP_GRAMMAR: {
        IA: {
            gnb: "ENG",
            lnbNm1: "문법",
            lnbCd1: "ENG00",
        },
    },
    ENGMP_READ: {
        IA: {
            gnb: "ENG",
            lnbNm1: "독해",
            lnbCd1: "ENG01",
        },
    },
    ENGMP_LISTEN: {
        IA: {
            gnb: "ENG",
            lnbNm1: "듣기",
            lnbCd1: "ENG02",
        },
    },
    ENGMP_VOCA: {
        IA: {
            gnb: "ENG",
            lnbNm1: "어휘",
            lnbCd1: "ENG03",
        },
    },
    ENGMP_WRITE: {
        IA: {
            gnb: "ENG",
            lnbNm1: "쓰기/영작",
            lnbCd1: "ENG04",
        },
    },

    /* 수학전문관(MAT) */
    MATHP_ALL: {
        IA: {
            gnb: "MAT",
            lnbNm1: "전체강좌",
            lnbCd1: "MATAL",
        },
    },
    MATHP_LVL: {
        IA: {
            gnb: "MAT",
            lnbNm1: "수준별",
            lnbCd1: "MAT00",
        },
    },
    MATHP_SCTN: {
        IA: {
            gnb: "MAT",
            lnbNm1: "영역별",
            lnbCd1: "MAT01",
        },
    },
    MATHP_QUEXV: {
        IA: {
            gnb: "MAT",
            lnbNm1: "문항별 해설영상",
            lnbCd1: "MAT02",
        },
    },

    /* 자격증&인증(LCN) */
    LCNSE_ALL: {
        IA: {
            gnb: "LCN",
            lnbNm1: "전체",
            lnbCd1: "LCNAL",
        },
    },
    LCNSE_CHNA: {
        IA: {
            gnb: "LCN",
            lnbNm1: "중국어",
            lnbCd1: "LCN00",
        },
    },
    LCNSE_JPAN: {
        IA: {
            gnb: "LCN",
            lnbNm1: "일본어",
            lnbCd1: "LCN01",
        },
    },
    LCNSE_KHIST: {
        IA: {
            gnb: "LCN",
            lnbNm1: "한국사능력검정",
            lnbCd1: "LCN02",
        },
    },
    LCNSE_CHSE: {
        IA: {
            gnb: "LCN",
            lnbNm1: "한자능력검정",
            lnbCd1: "LCN03",
        },
    },

    /* 나의 학습방(MYS) */
    StudyPlan: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 계획학습",
            lnbCd1: "MYS00",
        },
    },
    StudyPlan_Subject: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 계획학습",
            lnbCd1: "MYS00",
            lnbNm2: "과목별 보기",
            lnbCd2: "MYS0000",
        },
    },
    StudyPlan_Register: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 계획학습",
            lnbCd1: "MYS00",
            lnbNm2: "계획학습 등록",
            lnbCd2: "MYS0001",
        },
    },
    StudyPlan_Register_Calendar: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 계획학습",
            lnbCd1: "MYS00",
            lnbNm2: "계획학습 등록",
            lnbCd2: "MYS0001",
            lnbNm3: "요일별 학습할 강의 등록",
            lnbCd3: "MYS000100",
        },
    },
    StudyPlan_Change: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 계획학습",
            lnbCd1: "MYS00",
            lnbNm2: "계획학습 변경",
            lnbCd2: "MYS0002",
        },
    },
    StudyPlan_Change_Calendar: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 계획학습",
            lnbCd1: "MYS00",
            lnbNm2: "계획학습 변경",
            lnbCd2: "MYS0002",
            lnbNm3: "요일별 학습할 강의 변경",
            lnbCd3: "MYS000200",
        },
    },

    StudyState: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 학습현황",
            lnbCd1: "MYS01",
        },
    },
    StudyState_DAY: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 학습현황",
            lnbCd1: "MYS01",
            lnbNm2: "일간",
            lnbCd2: "MYS0100",
        },
    },
    StudyState_WEEK: {
        IA: {
            gnb: "MYS",
            lnbNm1: "나의 학습현황",
            lnbCd1: "MYS01",
            lnbNm2: "주간",
            lnbCd2: "MYS0101",
        },
    },
    StudyState_TOT: {
        IA: { gnb: "MYS", lnbNm1: "나의 학습현황", lnbCd1: "MYS01", lnbNm2: "월간", lnbCd2: "MYS0102" },
    },
    StudyAllTab: {
        IA: {
            gnb: "MYS",
            lnbNm1: "올탭 과외 학습",
            lnbCd1: "MYS03",
        },
    },

    /* AI학습관(AIS) */
    AISTUDY_ALL: {
        IA: {
            gnb: "AIS",
            lnbNm1: "전체",
            lnbCd1: "AIAL",
        },
    },
    AISTUDY_MATH: {
        IA: {
            gnb: "AIS",
            lnbNm1: "AI수학",
            lnbCd1: "AIS00",
        },
    },
    AISTUDY_ENGM: {
        IA: {
            gnb: "AIS",
            lnbNm1: "AI영어",
            lnbCd1: "AIS01",
        },
    },
    AISTUDY_ENGM_ENGLISH: {
        IA: {
            gnb: "AIS",
            lnbNm1: "AI영어",
            lnbCd1: "AIS01",
            lnbNm2: "중학 필수 AI 영문법",
            lnbCd2: "AIS0100",
        },
    },
    AISTUDY_ENGM_TEXTBOOK: {
        IA: {
            gnb: "AIS",
            lnbNm1: "AI영어",
            lnbCd1: "AIS01",
            lnbNm2: "교과서별 AI 영문법",
            lnbCd2: "AIS0101",
        },
    },

    /* TEST라운지(TST) */
    TESTL_ETST: {
        IA: {
            gnb: "TST",
            lnbNm1: "ETEST",
            lnbCd1: "TST00",
        },
    },
    TESTL_TRTST: {
        IA: {
            gnb: "TST",
            lnbNm1: "영수모의고사",
            lnbCd1: "TST01",
        },
    },
    TESTL_ELTST: {
        IA: {
            gnb: "TST",
            lnbNm1: "영어듣기 능력평가",
            lnbCd1: "TST02",
        },
    },
    ETST_SVTST: {
        IA: {
            gnb: "TST",
            lnbNm1: "학력평가 기출문제",
            lnbCd1: "TST03",
        },
    },
    TESTL_SVTST: {
        IA: {
            gnb: "TST",
            lnbNm1: "학력평가 기출문제",
            lnbCd1: "TST03",
        },
    },
    TESTL_HUTST: {
        IA: {
            gnb: "TST",
            lnbNm1: "학업성취도평가 대비",
            lnbCd1: "TST04",
        },
    },
    WrongAnswerNotes: {
        IA: {
            gnb: "TST",
            lnbNm1: "오답노트",
            lnbCd1: "TST05",
        },
    },
    TESTL_RSBPT: {
        IA: {
            gnb: "TST",
            lnbNm1: "올백TEST",
            lnbCd1: "TST06",
        },
    },

    /* 영어라운지(ELG) */
    EnglishLibrary: {
        IA: {
            gnb: "ELG",
            lnbNm1: "English Library",
            lnbCd1: "ELG00",
        },
    },
    EnglishVoca: {
        IA: {
            gnb: "ELG",
            lnbNm1: "VOCA 트레이닝",
            lnbCd1: "ELG01",
        },
    },
    EnglishVoca_Schedule: {
        IA: {
            gnb: "ELG",
            lnbNm1: "VOCA 트레이닝",
            lnbCd1: "ELG01",
            lnbNm2: "중학 필수어휘",
            lnbCd2: "ELG0100",
        },
    },
    EnglishVoca_Textbook: {
        IA: {
            gnb: "ELG",
            lnbNm1: "VOCA 트레이닝",
            lnbCd1: "ELG01",
            lnbNm2: "중학 교과서별 어휘",
            lnbCd2: "ELG0101",
        },
    },
    EnglishVoca_Textbook_AATB: {
        IA: {
            gnb: "ELG",
            lnbNm1: "VOCA 트레이닝",
            lnbCd1: "ELG01",
            lnbNm2: "중학 교과서별 어휘",
            lnbCd2: "ELG0101",
            lnbNm3: "학년 교과서 선택",
            lnbCd3: "ELG010100",
        },
    },
    EnglishVoca_Textbook_UNIT: {
        IA: {
            gnb: "ELG",
            lnbNm1: "VOCA 트레이닝",
            lnbCd1: "ELG01",
            lnbNm2: "중학 교과서별 어휘",
            lnbCd2: "ELG0101",
            lnbNm3: "단원 선택",
            lnbCd3: "ELG010101",
        },
    },
    EnglishVoca_HighSchoolVoca: {
        IA: {
            gnb: "ELG",
            lnbNm1: "VOCA 트레이닝",
            lnbCd1: "ELG01",
            lnbNm2: "고등 필수어휘",
            lnbCd2: "ELG0102",
        },
    },

    /* 학습서비스(시험대비 라운지)(SVC) */
    LiveQNA: {
        IA: {
            gnb: "SVC",
            lnbNm1: "시험대비 바로답변",
            lnbCd1: "SVC00",
        },
    },
    ALLZIP: {
        IA: {
            gnb: "SVC",
            lnbNm1: "교과서 ALL-ZIP",
            lnbCd1: "SVC01",
        },
    },
    ReferenceRoom: {
        IA: {
            gnb: "SVC",
            lnbNm1: "학습자료실",
            lnbCd1: "SVC02",
        },
    },
    StudyMusic: {
        IA: {
            gnb: "SVC",
            lnbNm1: "열공뮤직",
            lnbCd1: "SVC03",
        },
    },
    PerformExam: {
        IA: {
            gnb: "SVC",
            lnbNm1: "수행평가 가이드",
            lnbCd1: "SVC04",
        },
    },
    LiteratureLibrary: {
        IA: {
            nb: "SVC",
            lnbNm1: "문학도서관",
            lnbCd1: "SVC05",
        },
    },

    /* 진로진학(CRE) */
    // 메인
    STDLRNI: {
        IA: {
            gnb: "CRE",
            lnbNm1: "서울대 선배의 학습법",
            lnbCd1: "CRE00",
        },
    },
    DPMINTC: {
        IA: {
            gnb: "CRE",
            lnbNm1: "학과소개",
            lnbCd1: "CRE01",
        },
    },
    OCPTITV: {
        IA: {
            gnb: "CRE",
            lnbNm1: "직업인 인터뷰",
            lnbCd1: "CRE02",
        },
    },
    STDGIDE: {
        IA: {
            gnb: "CRE",
            lnbNm1: "과목별 학습가이드",
            lnbCd1: "CRE03",
        },
    },

    /* 같이라운지(LOG) */
    Reward: {
        IA: {
            gnb: "LOG",
            lnbNm1: "성적 우수 장학생",
            lnbCd1: "LOG00",
        },
    },

    /* 스타샵(STR) */
    MyStar: {
        IA: {
            gnb: "STR",
            lnbNm1: "나의 별 현황",
            lnbCd1: "STR00",
        },
    },
    MyStarGoal: {
        IA: {
            gnb: "STR",
            lnbNm1: "나의 목표",
            lnbCd1: "STR01",
        },
    },
    StarChange: {
        IA: {
            gnb: "STR",
            lnbNm1: "무엇을 바꿔볼까?",
            lnbCd1: "STR02",
        },
    },

    /* 마이페이지(MYP) */
    MyPage_Fav: {
        IA: {
            gnb: "MYP",
            lnbNm1: "찜한 강좌",
            lnbCd1: "MYP00",
        },
    },
    MyPage_Qna: {
        IA: {
            gnb: "MYP",
            lnbNm1: "나의 강좌 Q&A",
            lnbCd1: "MYP01",
        },
    },
    MyPage_Noti: {
        IA: {
            gnb: "MYP",
            lnbNm1: "알림",
            lnbCd1: "MYP02",
        },
    },
    MyPage_Note: {
        IA: {
            gnb: "MYP",
            lnbNm1: "1:1톡",
            lnbCd1: "MYP03",
        },
    },
    MyPage_Info: {
        IA: {
            gnb: "MYP",
            lnbNm1: "개인정보 수정",
            lnbCd1: "MYP04",
        },
    },
    MyPage_Info_SchoolSearch: {
        IA: {
            gnb: "MYP",
            lnbNm1: "개인정보 수정",
            lnbCd1: "MYP04",
            lnbNm2: "학교 찾기(팝업)",
            lnbCd2: "MYP0400",
        },
    },
    MyPage_Info_Textbook: {
        IA: {
            gnb: "MYP",
            lnbNm1: "개인정보 수정",
            lnbCd1: "MYP04",
            lnbNm2: "우리학교 교과서 설정",
            lnbCd2: "MYP0401",
        },
    },
    MyPage_Timetable: {
        IA: {
            gnb: "MYP",
            lnbNm1: "개인정보 수정",
            lnbCd1: "MYP04",
            lnbNm2: "표준시간표 강좌 변경",
            lnbCd2: "MYP0402",
        },
    },
    MyPage_Timetable_Change: {
        IA: {
            gnb: "MYP",
            lnbNm1: "개인정보 수정",
            lnbCd1: "MYP04",
            lnbNm2: "표준시간표 강좌 변경",
            lnbCd2: "MYP0402",
            lnbNm3: "변경 시간표 확인",
            lnbCd3: "MYP040200",
        },
    },

    /* 고객센터(CUS) */
    CUS_Notice: {
        IA: {
            gnb: "CUS",
            lnbNm1: "공지사항",
            lnbCd1: "CUS00",
        },
    },
    CUS_Faq: {
        IA: {
            gnb: "CUS",
            lnbNm1: "자주 묻는 질문",
            lnbCd1: "CUS01",
        },
    },
    CUS_Terms: {
        IA: {
            gnb: "CUS",
            lnbNm1: "약관보기",
            lnbCd1: "CUS02",
        },
    },

    SEARCH: {
        IA: {
            gnb: "SCH",
        },
    },
};
